"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var moment = require("moment");
var numeral = require("numeral");
var _ = require("lodash");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var localStorageUtils_1 = require("../../app/utils/localStorageUtils");
var metrikaUtils_1 = require("../../app/utils/metrikaUtils");
var imageZoomUtils_1 = require("../../app/utils/imageZoomUtils");
var commentsView_1 = require("./commentsView");
var cookieUtils_1 = require("../../app/utils/cookieUtils");
var scriptjs = require("scriptjs");
var Masonry = require("masonry-layout");
var imagesLoaded = require("imagesloaded");
var Settings = (function () {
    function Settings() {
    }
    return Settings;
}());
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.metricsSpentTime = 0;
        this.s3url = "audiobook/gets3url";
        this.numeral = numeral;
        this.workId = this.options.workId;
        this.statsIsLoading = ko.observable(true);
        this.workStatLoaded = ko.observable(false);
        this.totalCount = ko.observable(0);
        this.readingCount = ko.observable(0);
        this.savedCount = ko.observable(0);
        this.finishedCount = ko.observable(0);
        this.dislikedCount = ko.observable(0);
        this.startDate = ko.observable(moment().startOf("day").add(-6, "days"));
        this.endDate = ko.observable(moment().endOf("day"));
        this.booktrailerVideoUrl = ko.observable();
        this.showFullStats = ko.observable();
        this.currentChapter = ko.observable();
        this.chapterProgress = ko.observable();
        this.chapterDuration = ko.observable();
        this.chapterCurrentTime = ko.observable();
        this.progressComputed = ko.pureComputed(function () {
            return _this.chapterProgress();
        }).extend({
            rateLimit: {
                timeout: 30000,
                method: "notifyAtFixedRate"
            }
        });
        this.chapterEndTimeMessage = ko.pureComputed(function () {
            var duration = _this.chapterDuration(), currentTime = _this.chapterCurrentTime();
            if (isNaN(duration) || isNaN(currentTime))
                return "00:00";
            var value = duration - currentTime;
            if (Math.floor(value) <= 0)
                return _this.getTimeCode(0);
            return "-" + _this.getTimeCode(value);
        });
        this.firstPlay = true;
        this.audioVolume = ko.observable(1);
        this.audioSpeed = ko.observable(1);
        this.audioPlaying = ko.observable(false);
        this.audioSpeedOptions = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
        this.previousChapter = ko.pureComputed(function () {
            var index = _this.chapters.indexOf(_this.currentChapter());
            index--;
            if (index < 0)
                return null;
            return _this.chapters[index];
        });
        this.nextChapter = ko.pureComputed(function () {
            var index = _this.chapters.indexOf(_this.currentChapter());
            index++;
            if (index >= _this.chapters.length)
                return null;
            return _this.chapters[index];
        });
        this.loadPreviousChapter = function () {
            var ch = _this.previousChapter();
            if (ch) {
                _this.loadChapter(ch);
            }
        };
        this.loadNextChapter = function () {
            var ch = _this.nextChapter();
            if (ch) {
                _this.loadChapter(ch);
            }
        };
        this.constRewindStep = 30; // шаг перемотки
        this.backwardBtn = function () {
            _this.audio.currentTime -= _this.constRewindStep;
        };
        this.forwardBtn = function () {
            _this.audio.currentTime += _this.constRewindStep;
        };
        this.openSpeedPopover = function () {
            var self = _this;
            var buttons = [];
            var _loop_1 = function(i) {
                buttons.push({
                    text: i,
                    onClick: function () { return self.updateAudioSpeed(i); }
                });
            };
            for (var i = 0.25; i <= 2; i += 0.25) {
                _loop_1(i);
            }
            app.f7.actions($("#audioSpeedBtn")[0], buttons, false);
        };
        this.updateAudioSpeed = function (speed) {
            _this.audioSpeed(speed);
            _this.audio.playbackRate = speed;
        };
        this.togglePlay = function () {
            var playing = !_this.audioPlaying();
            var playAudio = function () {
                var playPromise = _this.audio.play();
                // In browsers that don’t yet support this functionality, playPromise won’t be defined.
                if (playPromise) {
                    playPromise.catch(function (error) {
                        console.error("Audio error: ", error);
                        var time = _this.audio.currentTime;
                        var src = _this.audio.src;
                        _this.audio.src = null;
                        _this.audio.src = src;
                        _this.audio.currentTime = time;
                    });
                }
            };
            if (playing) {
                if (_this.adultOnly && !(app.isAuthenticated || cookieUtils_1.default.getAdultUser())) {
                    _this.app.closePopup();
                    _this.app.f7.popup("#adultPopup");
                }
                else {
                    if (_this.firstPlay) {
                        var currentChapter = _.find(_this.chapters, function (x) { return x.id === _this.options.chapterId; });
                        _this.currentChapter(currentChapter);
                        ajaxUtils_1.AjaxUtils.get(_this.s3url, { path: currentChapter.url })
                            .done(function (result) {
                            if (!result.isSuccessful) {
                                alert(result.messages[0]);
                                return;
                            }
                            _this.audio.src = result.data;
                            playAudio();
                        });
                    }
                    else {
                        playAudio();
                    }
                    _this.audioPlaying(playing);
                }
            }
            else {
                _this.audio.pause();
                _this.updateReadingProgress();
                _this.audioPlaying(playing);
            }
        };
        this.toggleAudioVolume = function () {
            if (_this.audioVolume() > 0) {
                _this.savedVolume = _this.audioVolume();
                _this.audioVolume(0);
            }
            else {
                _this.audioVolume(_this.savedVolume);
            }
        };
        this.changeAudioSpeed = function (speed) {
            _this.audioSpeed(speed);
        };
        this.loadChapter = function (chapter) {
            _this.currentChapter(chapter);
            ajaxUtils_1.AjaxUtils.get(_this.s3url, { path: chapter.url })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.audio.src = result.data;
                _this.audio.play();
                _this.chapterProgress(0);
                _this.$timelineSeek.val(0);
                _this.updateReadingProgress();
            });
        };
        this.downloadFile = function (chapterId, viewModel, event) {
            if (!app.ensureAuth("Только зарегистрированные пользователи могут скачивать аудиокниги"))
                return;
            var $button = $(event.currentTarget);
            $button.attr("disabled", "disabled").addClass("is-loading");
            $.get(window["app"].rootUrl + "audiobook/download", { chapterId: chapterId })
                .done(function (result) {
                if (result.isSuccessful) {
                    window.location = result.data;
                }
            })
                .always(function () {
                $button.removeAttr("disabled").removeClass("is-loading");
            });
        };
        this.getTimeCode = function (num) {
            if (isNaN(num))
                return "00:00";
            var seconds = Math.floor(num);
            var hours = Math.floor(seconds / 3600);
            var minutes = Math.floor((seconds - (hours * 3600)) / 60);
            seconds = seconds - (hours * 3600) - (minutes * 60);
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            var result;
            if (hours > 0) {
                if (hours < 10) {
                    hours = "0" + hours;
                }
                result = hours + ":" + minutes + ":" + seconds;
            }
            else {
                result = minutes + ":" + seconds;
            }
            return result;
        };
        this.statsFilterData = ko.computed(function () {
            return {
                startDate: _this.startDate().toISOString(),
                endDate: _this.endDate().toISOString(),
                itemId: _this.workId,
                groupBy: "work"
            };
        });
        this.chapters = options.chapters;
        this.booktrailerVideoUrl(options.booktrailerVideoUrl);
        this.showFullStats(options.showFullStats);
        this.isModeratorOrAdmin = this.options.isModeratorOrAdmin;
        localStorageUtils_1.default.addToList(localStorageUtils_1.default.RecentlyViewedKey, options.workId);
        this.loadRecommendations();
        this.loadSettings();
        this.initAudioPlayer();
        this.adultOnly = options.adultOnly;
        $("#accordion-item-stats").on("accordion:opened", function () {
            ajaxUtils_1.AjaxUtils.get("work/work-stats", { workId: _this.workId })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.totalCount(result.data.totalCount);
                _this.readingCount(result.data.readingCount);
                _this.savedCount(result.data.savedCount);
                _this.finishedCount(result.data.finishedCount);
                _this.dislikedCount(result.data.dislikedCount);
            })
                .always(function () {
                _this.workStatLoaded(true);
            });
            if (_this.showFullStats()) {
                scriptjs([
                    ajaxUtils_1.AjaxUtils.getFullUrl("dist/js/amcharts?v=140717")
                ], function () {
                    ko.computed(function () {
                        _this.statsIsLoading(true);
                        _this.statsFilterData();
                        _this.loadDynamicChart(_this.isModeratorOrAdmin);
                    });
                    $("#accordion-item-stats").off("accordion:opened");
                });
            }
            else {
                $("#accordion-item-stats").off("accordion:opened");
            }
        });
        $("#accordion-item-materials").on("accordion:opened", function () {
            if ($("#masonry")[0]) {
                ajaxUtils_1.AjaxUtils.loadCss("dist/vendor/photoswipe/css/photoswipe.css");
                ajaxUtils_1.AjaxUtils.loadCss("dist/vendor/photoswipe/css/default-skin/default-skin.css");
            }
            setTimeout(function () {
                if ($("#masonry")[0] === undefined)
                    return;
                var masonry = new Masonry("#masonry", {
                    itemSelector: "figure",
                    gutter: ".gutter-sizer",
                    columnWidth: ".grid-sizer",
                    percentPosition: true
                });
                $("#masonry figure")["imagesLoaded"]()
                    .progress(function () {
                    masonry.layout();
                });
                $(window)
                    .on("resize", function () {
                    setTimeout(function () { return masonry.layout(); }, 200);
                });
                imageZoomUtils_1.default.initWorkMaterials();
            }, 200);
            $("#accordion-item-materials").off("accordion:opened");
        });
        $("#accordion-item-series").on("accordion:opened", function () {
            var $seriesSlider = $("#seriesSlider");
            ajaxUtils_1.AjaxUtils.get("work/getByIds", {
                workIds: _this.options.seriesWorkIds,
                checkPrivacy: false
            })
                .done(function (result) {
                if (!result.isSuccessful) {
                    $seriesSlider.hide();
                    return;
                }
                var $sliderWrapper = $seriesSlider.find(".swiper-wrapper");
                $sliderWrapper.removeClass("work-slider-loading");
                $seriesSlider.addClass("work-slider");
                $sliderWrapper.html(result.data.html);
                app.f7.swiper($seriesSlider[0], {
                    slidesPerView: "auto",
                    speed: 300,
                    spaceBetween: 8,
                    slidesPerGroup: 3,
                    grabCursor: true,
                    scrollbar: ".swiper-scrollbar"
                });
            }).fail(function () {
                $seriesSlider.hide();
            });
            $("#accordion-item-series").off("accordion:opened");
        });
        this.loadComments(null, null, false);
    }
    ViewModel.prototype.loadSettings = function () {
        var _this = this;
        var settings = localStorageUtils_1.default.get("audio.settings");
        if (settings === null || settings === undefined) {
            settings = {
                volume: 1,
                speed: 1,
                version: "1.0"
            };
        }
        this.audioVolume(1);
        this.audioSpeed(settings.speed || 1);
        this.audioVolume.subscribe(function () { return _this.saveSettings(); });
        this.audioSpeed.subscribe(function () { return _this.saveSettings(); });
    };
    ViewModel.prototype.saveSettings = function () {
        var settings = {
            volume: this.audioVolume(),
            speed: this.audioSpeed(),
            version: "1.0"
        };
        localStorageUtils_1.default.set("audio.settings", settings);
    };
    ViewModel.prototype.endOfAudio = function () {
        var _this = this;
        if (this.nextChapter()) {
            this.loadNextChapter();
            return;
        }
        if (this.chapters.length < this.options.totalChapterCount) {
            if (app.isAuthenticated) {
                this.app.f7.modal({
                    title: "Конец ознакомительного фрагмента",
                    text: "Книга находится в платном доступе.<br/>Чтобы продолжить, пожалуйста, оплатите доступ.",
                    buttons: [
                        {
                            text: "Ok",
                            onClick: function () { }
                        }
                    ]
                });
            }
            else {
                this.app.f7.modal({
                    title: "Конец ознакомительного фрагмента",
                    text: "Книга находится в платном доступе.<br/>" +
                        "Чтобы продолжить слушать аудиокнигу, пожалуйста, войдите в свой аккаунт на Author.Today или зарегистрируйтесь.",
                    buttons: [
                        {
                            text: "Отмена",
                            onClick: function () { }
                        },
                        {
                            text: "Войти",
                            onClick: function () {
                                _this.app.showLoginPopup();
                            }
                        }
                    ]
                });
            }
        }
        this.audio.pause();
        this.audioPlaying(false);
    };
    ViewModel.prototype.initAudioPlayer = function () {
        var _this = this;
        this.audio = new Audio();
        this.$timelineSeek = $("#timelineSeek");
        $(this.audio)
            .on("loadedmetadata", function () {
            console.info("Audio: loadedmetadata");
            _this.chapterDuration(_this.audio.duration);
        })
            .on("loadeddata", function () {
            console.info("Audio: loadeddata");
            if (_this.firstPlay) {
                _this.firstPlay = false;
                if (_this.options.chapterId === _this.currentChapter().id) {
                    _this.chapterProgress(_this.options.chapterProgress);
                    _this.audio.currentTime = _this.audio.duration * _this.options.chapterProgress / 100;
                }
                try {
                    metrikaUtils_1.default.reachGoal("startAudio", { from: "WorkPage" });
                }
                catch (ex) { }
                ;
                // запускаем подсчет метрики audio10Min
                _this.metricsLastTick = new Date().getTime();
                var spentTimeToCheck = 1000 * 60 * 10; // 10 минут
                var checkSpentTimeInterval = setInterval(function () {
                    if (_this.metricsSpentTime > spentTimeToCheck) {
                        clearInterval(checkSpentTimeInterval);
                        try {
                            metrikaUtils_1.default.reachGoal("audio10Min", { from: "WorkPage" });
                        }
                        catch (ex) { }
                        ;
                    }
                }, 2000);
            }
            _this.audio.volume = _this.audioVolume();
            _this.audio.playbackRate = _this.audioSpeed();
        })
            .on("loadstart waiting", function () {
            console.info("Audio: waiting");
            _this.audioPlaying(false);
        })
            .on("playing", function () {
            console.info("Audio: playing");
            _this.audioPlaying(true);
        })
            .on("timeupdate", function () {
            var progress = _this.audio.currentTime / _this.audio.duration * 100;
            if (!isNaN(progress)) {
                _this.chapterCurrentTime(_this.audio.currentTime);
                _this.chapterProgress(progress);
                _this.$timelineSeek.val(progress * 10);
            }
            else {
                _this.chapterCurrentTime(0);
                _this.chapterProgress(0);
            }
            if (_this.metricsLastTick) {
                var tick = new Date().getTime();
                var delta = tick - _this.metricsLastTick;
                if (delta < 1000) {
                    _this.metricsSpentTime += delta;
                }
                _this.metricsLastTick = tick;
            }
        })
            .on("ended", function () {
            console.info("Audio: ended");
            var endOfAudio = _this.audio.currentTime === _this.audio.duration;
            if (endOfAudio) {
                _this.endOfAudio();
            }
            else {
                _this.audioPlaying(true);
            }
        });
        this.audio.preload = "metadata";
        this.progressComputed.subscribe(function () {
            _this.updateReadingProgress();
        });
        this.$timelineSeek.on("input", function (e) {
            var progress = _this.$timelineSeek.val() / 10;
            _this.audio.currentTime = _this.audio.duration * progress / 100;
            _this.chapterProgress(progress);
        });
        var $volumeSeek = $("#volumeSeek");
        this.audioVolume.subscribe(function (volume) {
            _this.audio.volume = volume;
            $volumeSeek.val(volume * 100);
        });
        $volumeSeek.on("input", function (e) {
            _this.audioVolume($volumeSeek.val() / 100);
        });
        this.audioSpeed.subscribe(function (speed) {
            _this.audio.playbackRate = speed;
        });
        $(".chapter-available").each(function (i, el) {
            $(el).on("click", function (e) {
                if ($(e.target).is(".chapter-download") ||
                    $(e.target).parents(".chapter-download").length)
                    return;
                _this.loadChapter(_this.chapters[i]);
            });
        });
        if (location.hash === "#startAudio") {
            this.togglePlay();
        }
    };
    ViewModel.prototype.updateReadingProgress = function () {
        var data = {
            wId: this.workId,
            cId: this.currentChapter().id,
            wp: 0,
            cp: this.chapterProgress(),
            sId: this.options.sessionId
        };
        ajaxUtils_1.AjaxUtils.post(app.statsApiUrl + ("audiobook/update-progress?" + $.param(data)), null)
            .done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
                return;
            }
        });
    };
    ViewModel.prototype.loadRecommendations = function () {
        var $recommendationsSlider = $("#recommendationsSlider");
        ajaxUtils_1.AjaxUtils.get("widget/workRecommendations", {
            workId: this.workId,
            format: "audiobook"
        })
            .done(function (result) {
            if (!result.isSuccessful) {
                $recommendationsSlider.hide();
                return;
            }
            var $sliderWrapper = $recommendationsSlider.find(".swiper-wrapper");
            $sliderWrapper.removeClass("work-slider-loading");
            $recommendationsSlider.addClass("work-slider");
            $sliderWrapper.html(result.data.html);
            app.f7.swiper($recommendationsSlider[0], {
                slidesPerView: "auto",
                speed: 300,
                spaceBetween: 8,
                slidesPerGroup: 3,
                grabCursor: true,
                scrollbar: ".swiper-scrollbar"
            });
        })
            .fail(function () {
            $recommendationsSlider.hide();
        });
    };
    ViewModel.prototype.loadDynamicChart = function (withFraud) {
        var _this = this;
        if (withFraud === void 0) { withFraud = false; }
        var daysInPerios = Math.floor((this.endDate() - this.startDate()) / (1000 * 60 * 60 * 24));
        var minPeriod = "DD";
        var categoryBalloonDateFormat = "MMMM DD, YYYY";
        if (daysInPerios > 40) {
            minPeriod = "MM";
            categoryBalloonDateFormat = "MMMM, YYYY";
        }
        ajaxUtils_1.AjaxUtils.get("report/user-activity-data", this.statsFilterData())
            .done(function (result) {
            // @ts-ignore
            _this.dynamicChart = AmCharts.makeChart("statsChartdiv", {
                language: "ru",
                type: "serial",
                theme: "light",
                valueAxes: [
                    {
                        id: "countAxis",
                        axisAlpha: 0,
                        position: "left",
                        integersOnly: true,
                        title: "Количество просмотров"
                    }, {
                        title: "Время чтения, часы",
                        id: "durationAxis",
                        axisAlpha: 0,
                        gridAlpha: 0,
                        position: "right"
                    }
                ],
                graphs: [
                    {
                        balloonText: "Просмотров: [[value]]",
                        fillAlphas: 0.7,
                        legendValueText: "[[value]]",
                        type: "column",
                        valueField: "totalViewCount",
                        valueAxis: "countAxis"
                    }, {
                        balloonText: "Время прослушивания: [[value]]",
                        type: "smoothedLine",
                        bullet: "round",
                        bulletBorderAlpha: 1,
                        useLineColorForBulletBorder: true,
                        bulletColor: "#FFFFFF",
                        hideBulletsCount: 30,
                        legendValueText: "[[value]] ч.",
                        fillAlphas: 0,
                        valueField: "spentTime",
                        valueAxis: "durationAxis"
                    }
                ],
                chartCursor: {
                    categoryBalloonDateFormat: categoryBalloonDateFormat,
                    cursorAlpha: 0.1,
                    cursorColor: "#000000",
                    fullWidth: true,
                    valueBalloonsEnabled: false,
                    zoomable: false
                },
                dataDateFormat: "DD.MM.YYYY",
                categoryField: "date",
                categoryAxis: {
                    parseDates: true,
                    dashLength: 1,
                    minorGridEnabled: true,
                    minPeriod: minPeriod
                },
                legend: {
                    equalWidths: false,
                    useGraphSettings: true,
                    align: "center"
                },
                dataProvider: result.data,
                pathToImages: app.rootUrl + "dist/vendor/amcharts/images/"
            });
            _this.statsIsLoading(false);
        });
        if (withFraud) {
            ajaxUtils_1.AjaxUtils.get("report/user-activity-fraud-data", this.statsFilterData())
                .done(function (result) {
                var daysInPerios = Math.floor((_this.endDate() - _this.startDate()) / (1000 * 60 * 60 * 24));
                var minPeriod = "DD";
                var categoryBalloonDateFormat = "MMMM DD, YYYY";
                if (daysInPerios > 40) {
                    minPeriod = "MM";
                    categoryBalloonDateFormat = "MMMM, YYYY";
                }
                _this.fraudDynamicChart = AmCharts.makeChart("fraudStatsChartdiv", {
                    language: "ru",
                    type: "serial",
                    theme: "light",
                    valueAxes: [
                        {
                            id: "countAxis",
                            axisAlpha: 0,
                            position: "left",
                            integersOnly: true,
                            title: "Количество просмотров"
                        }, {
                            title: "Время чтения, часы",
                            id: "durationAxis",
                            axisAlpha: 0,
                            gridAlpha: 0,
                            position: "right"
                        }
                    ],
                    titles: [
                        {
                            "text": "Подозрительные данные"
                        }
                    ],
                    graphs: [
                        {
                            balloonText: "Просмотров: [[value]]",
                            fillAlphas: 0.7,
                            legendValueText: "[[value]]",
                            type: "column",
                            valueField: "totalViewCount",
                            valueAxis: "countAxis",
                            lineColor: "#d770ad"
                        }, {
                            balloonText: "Время чтения: [[value]]",
                            type: "smoothedLine",
                            bullet: "round",
                            bulletBorderAlpha: 1,
                            useLineColorForBulletBorder: true,
                            lineColor: "#ed9121",
                            hideBulletsCount: 30,
                            legendValueText: "[[value]] ч.",
                            fillAlphas: 0,
                            valueField: "spentTime",
                            valueAxis: "durationAxis"
                        }
                    ],
                    chartCursor: {
                        categoryBalloonDateFormat: categoryBalloonDateFormat,
                        cursorAlpha: 0.1,
                        cursorColor: "#000000",
                        fullWidth: true,
                        valueBalloonsEnabled: false,
                        zoomable: false
                    },
                    dataDateFormat: "DD.MM.YYYY",
                    categoryField: "date",
                    categoryAxis: {
                        parseDates: true,
                        dashLength: 1,
                        minorGridEnabled: true,
                        minPeriod: minPeriod
                    },
                    legend: {
                        equalWidths: false,
                        useGraphSettings: true,
                        align: "center"
                    },
                    dataProvider: result.data,
                    pathToImages: window["app"].rootUrl + "dist/vendor/amcharts/images/"
                });
                _this.statsIsLoading(false);
            });
        }
        ;
    };
    ViewModel.prototype.setAdultCookie = function () {
        cookieUtils_1.default.setAdultUser();
        this.app.closePopup();
        this.togglePlay();
    };
    return ViewModel;
}(commentsView_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=audiobookView.js.map